// agendaFormatters.js

import { isToday } from 'date-fns';

import { getCalendarEventMetaLabel } from 'views/calendar/shared/calendarUtils';

const hasTimeComponent = (date) => {
  if (!date) return false;
  return date.getHours() !== 0 || date.getMinutes() !== 0;
};

export const formatAgendaEventMeta = (item, language) => {
  const fieldLabel = getCalendarEventMetaLabel(item);
  if (!item?.date) return fieldLabel;

  const date = item.date;
  const timeLabel = hasTimeComponent(date)
    ? date.toLocaleTimeString(language || 'en', { hour: 'numeric', minute: '2-digit' })
    : '';

  if (timeLabel && fieldLabel) return `${fieldLabel} · ${timeLabel}`;
  return timeLabel || fieldLabel;
};

export const formatAgendaDayLabel = (date, language) => {
  if (isToday(date)) return 'Today';
  return date.toLocaleDateString(language || 'en', { weekday: 'short' });
};

export const formatAgendaMonthLabel = (date, language) => (
  date.toLocaleDateString(language || 'en', { month: 'short' })
);
